import { SendEventProps } from '../../interfaces/biEvents';

export const mpAboutTheGigViewed = () =>
    ({
        eventName: 'Gig page -  about the gig viewed',
    } satisfies SendEventProps);
